import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const getPromptEditorStyles = makeStyles({
  promptEditorRoot: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground1,

    '&.disabled .prompt-editor-text-container': {
      color: '#999',
    },

    '& .prompt-editor-text-container': {
      flexGrow: 1,
      lineHeight: '25px',
      fontSize: 14,
      fontWeight: 400,
      color: '#242424',
      position: 'relative',
      '& .prompt-textarea': {
        width: '100%',
        ...shorthands.borderRadius('8px'),
        ...shorthands.border('1px', 'solid', '#BDBDBD'),
        ...shorthands.padding('12px', '12px', '48px', '12px'),
        ...shorthands.overflow('hidden'),
        '&::after': {
          height: '4px',
          clipPath: 'none',
          backgroundColor: '#464feb',
          ...shorthands.borderColor('#464feb'),
        },
        '& textarea': {
          ...shorthands.padding('0px', '0px', '0px', '0px'),
          minHeight: '100px',
        },
      },
      '& .action-bar': {
        position: 'absolute',
        bottom: '12px',
        right: '12px',
        '& .generate-button.enabled': {
          color: tokens.colorNeutralForeground2BrandHover,
        },
        '& svg': {
          height: '18px',
          width: '18px',
        },
      },
    },
  },
});
